import React, { Fragment } from 'react'
import LoginPage from '../../Components/Auth/LoginPage'

const Login = () => {
    return (
        <Fragment >
            <LoginPage />
        </Fragment>
    )
}

export default Login